import React from "react"

import '../App.css'

import Menu from "../components/Menu";
import PostComponent from "../components/PostComponent";
import Footer from "../components/Footer";

const Post = () => {

    return (
        <>
            <header>
                <Menu/>
            </header>
            <PostComponent/>
            <Footer/>
        </>
    );
}

export default Post;